<template>
    <div class="el-row tasks-list-wrapper">
        <div class="card-deal-header deals-list-header caption-block">
            <div class="title">
                {{ title }}
            </div>
            <transition name="slide-in">
                <column-settings v-if="columnSettingsShow" :columns-model="columnsModel" :attributes="attributes" />
            </transition>
            <transition name="slide-in">
                <filter-settings
                    v-show="filterSettingsShow"
                    :filter="filterModel"
                    :attributes="attributes"
                    @filterApplied="filterApplied"
                />
            </transition>
            <div class="actions deals-menu">
                <div :class="[ 'filter','icon-filter','icon',{ 'disabled': !isAllTaskFilterPresetSet} ]" @click="filterSettingsShow = !filterSettingsShow"></div>
                <div class="icon-settings icon" @click="columnSettingsShow = !columnSettingsShow"></div>
            </div>
        </div>
        <div class="tasks-info">
            <div class="row">
                <div class="label">
                    Фильтрация:
                </div>
                <div class="value" v-if="isAllTaskFilterPresetSet">
                    {{ filterTitle }}
                </div>
                <div class="value" v-else>
                    {{ this.getFilterPresetName() | uppercase }}
                </div>
            </div>
            <div class="row">
                <div class="label">
                    Всего найдено:
                </div>
                <div class="value">
                    {{ pagesInfo.total }}
                </div>
            </div>
        </div>
        <div class="tasks-list">
            <div class="tasks-card card" v-for="task in tasks" :key="task.id" @click="goToTask(task.id)">
                <div class="row title black" v-if="!attributes.id.hide">
                    <div class="label">
                        {{ attributes.id.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.id ? task.id : '' }}
                    </div>
                </div>
                <div class="row title" v-if="!attributes.title.hide">
                    <div class="value">
                        {{ task.title ? task.title : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.status_id.hide">
                    <div class="label">
                        {{ attributes.status.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.status.name ? task.status.name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.priority.hide">
                    <div class="label">
                        {{ attributes.priority.name | uppercase }}:
                    </div>
                    <div :class="[valueClass, getPriorityClass(task.priority)]">
                        {{ task.priority ? getPriorityName(task.priority) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.contact_name.hide">
                    <div class="label">
                        {{ attributes.contact_name.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.deal && task.lead ? getContactName(task) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.contact_phone.hide">
                    <div class="label">
                        {{ attributes.contact_phone.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.deal && task.lead ? getContactPhone(task) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.entity_address.hide">
                    <div class="label">
                        {{ attributes.entity_address.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.deal || task.lead ? getEntityAddress(task) : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.assigned_user_id.hide">
                    <div class="label">
                        {{ attributes.assigned_user_id.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.assigned_user.full_name ? task.assigned_user.full_name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.planned.hide">
                    <div class="label">
                        {{ attributes.planned.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.planned ? task.planned : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.related_entity_id.hide">
                    <div class="label">
                        {{ attributes.related_entity_id.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.related_entity_id ? task.related_entity_id : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.created_user_id.hide">
                    <div class="label">
                        {{ attributes.created_user_id.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.created_user.full_name ? task.created_user.full_name : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.finished.hide">
                    <div class="label">
                        {{ attributes.finished.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ task.finished ? task.finished : '' }}
                    </div>
                </div>
            </div>
            <div class="pagination-wrapper" v-if="pagesInfo.total">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :pager-count="5"
                    @current-change="getCurrentPage"
                />
            </div>
        </div>
        <ag-grid-vue
            class="fake-grid"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
        />
    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import ColumnSettings from '@/components/ColumnSettingsMobile';
import FilterSettings from './FilterSettingsMobile';
import moment from 'moment';
import localReferences from '@/helpers/localReferences';
import { pickerOptions } from '@/common/pickerOptions';
import { eventBus } from '@/common/eventBus';
import defaultSettings from './defaultSettings';

const initialFilterModel = {
    id: null,
    status_id: [],
    title: null,
    assigned_user_id: [],
    planned: [],
    related_entity_id: null,
    created_user_id: [],
    finished: [],
    contact_name: null,
    contact_phone: null
};

export default {
    name: 'TasksListMobile',
    components: {
        ColumnSettings,
        FilterSettings,
        AgGridVue
    },
    data() {
        return {
            title: 'Список задач',
            defaultSettings: defaultSettings,
            valueClass: 'value',
            settingsObj: {},
            attributes: {
                'id': {
                    hide: false,
                    name: 'ID'
                },
                'status_id': {
                    hide: false,
                    name: 'статус'
                },
                'status': {
                    hide: false,
                    name: 'статус',
                    notGridColumn: true
                },
                'priority': {
                    hide: false,
                    name: 'приоритет'
                },
                'title': {
                    hide: false,
                    name: 'название'
                },
                'assigned_user_id': {
                    hide: false,
                    name: 'исполнитель'
                },
                'planned': {
                    hide: false,
                    name: 'срок'
                },
                'related_entity_id': {
                    hide: false,
                    name: 'сделка'
                },
                'created_user_id': {
                    hide: false,
                    name: 'постановщик'
                },
                'finished': {
                    hide: false,
                    name: 'дата время завершения'
                },
                'contact_name': {
                    hide: false,
                    name: 'имя контакта'
                },
                'contact_phone': {
                    hide: false,
                    name: 'телефон контакта'
                },
                'entity_address': {
                    hide: false,
                    name: 'адрес'
                },
                '0': {
                    hide: false,
                    name: 'Иконка настроек'
                }
            },
            fieldsNames: {},
            isFilterFormVisible: false,
            filterSettingsShow: false,
            columnSettingsShow: false,
            filterPresets: [
                {
                    alias: 'all',
                    title: 'все',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.id],
                        status_id: [localReferences.taskStatuses.assigned, localReferences.taskStatuses.onCheck]
                    }
                },
                {
                    alias: 'overdue',
                    title: 'просроченные',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.id],
                        status_id: [localReferences.taskStatuses.assigned],
                        planned: [null, moment().subtract(1, 'days').endOf('day').format('D.MM.YYYY')]
                    }
                },
                {
                    alias: 'today',
                    title: 'сегодня',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.id],
                        status_id: [localReferences.taskStatuses.assigned],
                        planned: [moment().startOf('day').format('D.MM.YYYY'), moment().endOf('day').format('D.MM.YYYY')]
                    }
                },
                {
                    alias: 'tomorrow',
                    title: 'завтра',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.id],
                        status_id: [localReferences.taskStatuses.assigned],
                        planned: [moment().add(1, 'days').startOf('day').format('D.MM.YYYY'), null]
                    }
                },
                {
                    alias: 'timeless',
                    title: 'без срока',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.id],
                        status_id: [localReferences.taskStatuses.assigned, localReferences.taskStatuses.onCheck],
                        planned: ['NULL', 'NULL']
                    }
                }
            ],
            filterModel: { ...initialFilterModel },
            columnsModel: [],
            sortModel: {},
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            loading: true,
            columnDefs: [],
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    comparator: () => {
                        return 0;
                    },
                    cellClass: 'column-text'
                }
            },
            pickerOptions
        };
    },
    created() {
        eventBus.$on('hideColumnSettings', () => {
            this.columnSettingsShow = false;
            this.scrollToTop();
        });
        eventBus.$on('hideFilterSettings', () => {
            this.filterSettingsShow = false;
            this.scrollToTop();
        });
        eventBus.$on('newColumnSettings', table => {
            this.saveSetting(table).then(
                () => {
                    this.setSettings();
                }).catch(
                error => {
                    console.log(error);
                });
        });

        Object.keys(this.attributes).forEach((item) => {
            if (!this.attributes[item].notGridColumn) {
                let fieldName = item;
                const needle = 'contact_';
                const string = 'contact.';
                if (~item.indexOf(needle)) {
                    fieldName = item.replace(needle, string);
                }
                this.columnDefs.push({ headerName: '', field: fieldName });
            }
        });
    },
    computed: {
        tasks() {
            return this.$store.state.tasks.tasks;
        },
        pagesInfo() {
            return this.$store.state.tasks.pages;
        },
        status() {
            return this.$store.state.references.taskStatuses;
        },
        employers() {
            return this.$store.state.references.employers;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        filterAlias() {
            return this.$route.meta.filterAlias || 'all';
        },
        filterPreset() {
            const filter = this.filterPresets.filter(item => item.alias === this.filterAlias)[0].filter || {};
            return { ...initialFilterModel, ...filter };
        },
        isAllTaskFilterPresetSet() {
            return this.filterAlias === 'all';
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    const getNamesFrom = (obj) => {
                        if (Object.keys(obj).length !== 0) {
                            return (this.fieldsNames[field] + ': ' + this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ') + '; ');
                        } else {
                            return '';
                        }
                    };
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'assigned_user_id':
                            case 'created_user_id':
                                result += getNamesFrom(this.employers);
                                break;
                            case 'status_id':
                                result += getNamesFrom(this.status);
                                break;
                            case 'finished':
                            case 'planned':
                                result += `${this.fieldsNames[field]} : ${this.filterModel[field][0]} по ${this.filterModel[field][1]}; `;
                                break;
                            default:
                                result += (this.fieldsNames[field] + ': ' + this.filterModel[field] + '; ');
                        }
                    }
                }
            }
            return result;
        }
    },
    mounted() {
        Object.keys(this.attributes).forEach((item) => {
            this.$set(this.fieldsNames, item, this.attributes[item].name);
        });

        this.$store.dispatch('preferences/getPreferences').then(
            () => {
                this.setSettings();
            }).catch(
            error => {
                console.log(error);
            }).finally(() => {
            if (this.isAllTaskFilterPresetSet) {
                this.getDataFromServer(true, this.filterPreset);
            } else {
                this.getDataFromServer(false, this.filterPreset);
            }
        });
    },
    methods: {
        setSettings() {
            let settings;
            if (!this.setting || !this.setting.tasks) {
                settings = this.defaultSettings.tasks;
            } else {
                settings = this.setting.tasks;
            }

            this.columnsModel = JSON.parse(JSON.stringify(settings.table));
            this.formatColId();
            this.pageModel = JSON.parse(JSON.stringify(settings.page));

            if (this.isAllTaskFilterPresetSet) {
                this.filterModel = { ...settings.filter, ...this.filterPreset };
            } else {
                this.filterModel = JSON.parse(JSON.stringify(settings.filter));
            }

            this.setColumnsList(this.columnsModel);
        },
        //меняем символ . на _ для названий столбцов
        formatColId() {
            const needle = '.';
            const string = '_';
            this.columnsModel.forEach((item) => {
                const name = item.colId;
                if (~name.indexOf(needle)) {
                    this.$set(item, 'colId', name.replace(needle, string));
                }
            });
        },
        //создаём объект с корректными именами столбцов для отправки на сервер
        convertColNames(columnSettings) {
            const needle = 'contact_';
            const string = 'contact.';
            const settingsObj = columnSettings.map(item => Object.assign({}, item));
            settingsObj.forEach((item) => {
                const name = item.colId;
                if (~name.indexOf(needle)) {
                    item.colId = name.replace(needle, string);
                }
            });

            return settingsObj;
        },
        //проставляем hide из настроек с сервера для всех полей
        setColumnsList(columnSettings) {
            columnSettings.forEach((item) => {
                const colName = item.colId;
                if (Object.prototype.hasOwnProperty.call(this.attributes, colName)) {
                    this.attributes[colName].hide = item.hide;
                }
            });
        },
        goToTask(id) {
            const route = {
                name: 'task-card',
                params: { id: id }
            };

            this.$router.push(route);
        },
        getDataFromServer(runSaveSettings = true, filter = null) {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: [
                    {
                        colId: 'planned', sort: 'asc'
                    }
                ],
                filter: filter || this.filterModel
            };
            this.loading = true;
            this.$store.dispatch('tasks/getPaginatedList', requestParams).then(
                response => {
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    if (runSaveSettings) {
                        this.saveSetting();
                    }
                    this.loading = false;
                }).catch(
                error => {
                    console.log(error);
                });
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        async saveSetting(table = this.columnsModel) {
            table = this.convertColNames(table);
            const data = {
                'tasks': {
                    'table': table,
                    'sort': [
                        {
                            colId: 'planned', sort: 'asc'
                        }
                    ],
                    'filter': this.filterModel,
                    'page': this.pageModel
                }
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        getPriorityName(value) {
            let priorityName = 'Неизвестно';
            switch (value) {
                case localReferences.taskPriorities.low:
                    priorityName = 'Низкий';
                    break;
                case localReferences.taskPriorities.middle:
                    priorityName = 'Средний';
                    break;
                case localReferences.taskPriorities.high:
                    priorityName = 'Высокий';
                    break;
            }
            return priorityName;
        },
        getPriorityClass(value) {
            let priorityClass = '';
            if (value) {
                switch (value) {
                    case localReferences.taskPriorities.low:
                        priorityClass = '';
                        break;
                    case localReferences.taskPriorities.middle:
                        priorityClass = 'light-blue';
                        break;
                    case localReferences.taskPriorities.high:
                        priorityClass = 'light-red';
                        break;
                }
            }

            return priorityClass;
        },
        getContactName(task) {
            let name = '';
            if (task.related_entity_type === localReferences.entities.deal) {
                if (task.deal && task.deal.contact) {
                    name = task.deal.contact.name;
                }
            } else if (task.related_entity_type === localReferences.entities.lead) {
                if (task.lead && task.lead.contact) {
                    name = task.lead.contact.name;
                }
            }

            return name;
        },
        getContactPhone(task) {
            let contactPhones = [];
            if (task.related_entity_type === localReferences.entities.deal) {
                if (task.deal && task.deal.contact && task.deal.contact.contact_phones) {
                    contactPhones = task.deal.contact.contact_phones;
                }
            } else if (task.related_entity_type === localReferences.entities.lead) {
                if (task.lead && task.lead.contact && task.lead.contact.contact_phones) {
                    contactPhones = task.lead.contact.contact_phones;
                }
            }
            return contactPhones.reduce((result, item) => result + item.phone + '; ', '').slice(0, -2);
        },
        getEntityAddress(task) {
            if (task.related_entity_type === localReferences.entities.deal && task.deal) {
                return task.deal.address;
            }
            if (task.related_entity_type === localReferences.entities.lead && task.lead) {
                return task.lead.address;
            }
            return '';
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        getFilterPresetName() {
            let title = '';
            this.filterPresets.forEach((item) => {
                if (item.alias === this.filterAlias) {
                    title = item.title;
                }
            });
            return title;
        }
    },
    watch: {
        filterAlias(value) {
            if (value) {
                if (this.isAllTaskFilterPresetSet) {
                    this.filterModel = { ...this.filterPreset };
                    this.getDataFromServer();
                } else {
                    this.getDataFromServer(false, this.filterPreset);
                }
            }
        }
    },
    filters: {
        uppercase: function(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }
};
</script>
